import { Breakpoints } from '../types';

export const breakpoints: Breakpoints = {
  sm: '(min-width: 0)',
  md: '(min-width: 40rem)',
  lg: '(min-width: 64rem)',
  xl: '(min-width: 75rem)',
  xxl: '(min-width: 90rem)',
}
